import { createSelector, select } from '@ngrx/store';

import { StateSelector } from '@fcom/core/selectors/selector-utils';
import { FinnairBoundItem } from '@fcom/dapi/api/models';
import { FinnairAirCalendarChangeListResponse } from '@fcom/dapi/api/models/finnair-air-calendar-change-list-response';

import { ManageBookingFeatureState, ManageBookingState } from '../../interfaces';
import { selectManageBookingState } from './feature.selector';

const _getChangeBounds = createSelector(selectManageBookingState, (state: ManageBookingState) =>
  [state.change.outbound, state.change.inbound].filter(Boolean)
);

const _getChangeBoundIds = createSelector(_getChangeBounds, (bounds: [FinnairBoundItem, FinnairBoundItem]) =>
  bounds.filter(Boolean).map(({ id }) => id)
);

const _getChangeDates = createSelector(selectManageBookingState, (state: ManageBookingState) => state.change.dates);

const _getChangeList = createSelector(selectManageBookingState, (state: ManageBookingState) => state.change.list);

export const getChangeBounds = (): StateSelector<ManageBookingFeatureState, FinnairBoundItem[]> =>
  select(_getChangeBounds);
export const getChangeBoundIds = (): StateSelector<ManageBookingFeatureState, string[]> => select(_getChangeBoundIds);

export const getChangeDates = (): StateSelector<ManageBookingFeatureState, string[]> => select(_getChangeDates);

export const getChangeList = (): StateSelector<ManageBookingFeatureState, FinnairAirCalendarChangeListResponse> =>
  select(_getChangeList);
